import { Suspense } from "react";
import VerifyPhonePage from "@/app/auth/verify/verify";
import AuthSkeleton from "@/components/auth-skeleton";

export default function AuthVerifyPage() {
  return (
    <Suspense fallback={<AuthSkeleton />}>
      <VerifyPhonePage />
    </Suspense>
  )
}
